// useNavigationGuard.ts
import { useCallback } from 'react';

import { useBlocker } from './useBlocker';

/**
 * 未保存の変更がある状態での画面離脱を確認ダイアログで止める。
 *
 * onDiscard には「破棄が確定したときの後始末」を渡す。window.confirm はメインスレッドを
 * 同期ブロックするため、表示中に自動保存 debounce の待ち時間が経過していてもコールバックは
 * 実行されず、OK でブロックが解けた直後に走る。破棄を選んだのに保存（と自動配車）が
 * 実行される事故を防ぐには、遷移を許可する前にここで保存タイマーを止める必要がある。
 *
 * キャンセル時に呼ばないのは、その場に留まって編集を続ける意図であり、自動保存が
 * 生きたままなのが正しいため。
 */
export function useNavigationGuard(isDirty: boolean, onDiscard?: () => void, message?: string) {
  const handleConfirm = useCallback(
    () => {
      const confirmed = window.confirm(message || '変更内容が破棄されますが、よろしいですか？');
      if (confirmed) onDiscard?.();

      return confirmed;
    },
    [message, onDiscard]
  );

  useBlocker(isDirty, handleConfirm);
}
